import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function ComercializadoraAnexo21y22RMF2026DatosGenerales() {
  return (
    <CategoryPage
      category="comercializadoraAnexo21Y22Rmf2026DatosGenerales2026"
      pageTitle="Datos Generales 2026"
    />
  );
}

export default ComercializadoraAnexo21y22RMF2026DatosGenerales;
